/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Link, Typography } from "@material-ui/core";
import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  rootRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100% ",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "0.8rem",
    },
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  heading: {
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 500,
    fontSize: "1.5rem",
    lineHeight: "1.8rem",
    color: "#0DB14B",
    // background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  iconLabelRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.5rem",
    color: "#666666",
    fontSize: "0.875rem",
    lineHeight: "0.875rem",
  },
}));

const FooterLinks = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.rootRow}>
        <Typography className={classes.heading}>Contact us</Typography>
        {/* Phone */}
        <Link
          href="tel:08071844962"
          rel="noopener"
          title="Phone"
          target="_blank"
          className={classes.iconLabelRow}
        >
          <img
            src="/images/icons/footer/phone.svg"
            alt={AppConfig.imageAltText}
            width={18}
            height={18}
          />
          08071844962
        </Link>

        {/* WhatsApp */}
        <Link
          href="https://wa.me/+919513689999"
          rel="noopener"
          title="Whatsapp"
          target="_blank"
          className={classes.iconLabelRow}
        >
          <img
            src="/images/icons/footer/whatsapp.svg"
            alt={AppConfig.imageAltText}
            width={18}
            height={18}
          />
          +91 9513689999
        </Link>

        {/* Email */}
        <Link
          href="mailto:mail@sentientdevelopers.com"
          rel="noopener"
          title="Email"
          target="_blank"
          className={classes.iconLabelRow}
        >
          <img
            src="/images/icons/footer/mail.svg"
            alt={AppConfig.imageAltText}
            width={18}
            height={18}
          />
          mail@sentientdevelopers.com
        </Link>
      </div>
    </React.Fragment>
  );
};

export default FooterLinks;
